export const apiCreate = (): string => '/commercial/tutorials/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/tutorials/' : `/commercial/tutorials/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/tutorials/update/${id}`
export const apiDelete = (id: string): string => `/commercial/tutorials/${id}`
